import { render } from "./outro.vue?vue&type=template&id=6425b4ac"
import script from "./outro.vue?vue&type=script&lang=js"
export * from "./outro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__